<script>
import { mapActions, mapGetters } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import downloader from '@/mixins/downloader';

export default {
  name: 'AvContractListItem',
  mixins: [downloader, snackbarMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    ...mapActions('avContractList', ['downloadReport']),
    onDelete() {
      this.$emit('delete', this.avContract);
    },
    _downloadReport() {
      return this.downloadReport(this.avContract.id)
        .then((response) => {
          this.getDownloadContent(response, 'av_contract_report.pdf');
        }).catch((error) => {
          console.log(`Fehler: ${error.response}`);
          this.showErrorMessage('Beim Erstellen des Berichts ist ein Fehler aufgetreten.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/avContract/show/${avContract.id}`">{{ avContract.name }}</router-link>
    </td>
    <td>
      {{ avContract.organizationalUnit ? avContract.organizationalUnit.translatedName : null
      }}</td>
    <td>{{ avContract.responsibleUser ? avContract.responsibleUser.translatedName : null }}</td>
    <td>{{ avContract.examState ? avContract.examState.translatedName : null }}</td>
    <td/>
    <td width="160" align="right">
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDownloadRights"
               @click.native="_downloadReport" flat icon slot="activator">
          <v-icon small>cloud_download</v-icon>
        </v-btn>
        <span>Bericht herunterladen</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn v-if="auth.hasDeleteRights"
               @click.native="onDelete" flat icon slot="activator" :disabled="avContract.isDelete">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
